export default function MFooter(){
    return(
    // <footer className="Footer">
    //     <p href="/contacts"> contact us</p>
    // </footer>
    <div></div>
    )
}